import { Component, OnDestroy, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { FunctionUtil } from '../../utils';
import { MatDatepicker } from '@angular/material/datepicker';
import moment from 'moment';
import { Moment } from 'moment';
import { BaseComponent } from '@shared-features/components/base-component/base.component';

export const DATE_INPUT_FORMATE = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: '',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-birth-date',
  templateUrl: './birth-date.component.html',
  styleUrls: ['./birth-date.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: BirthDateComponent,
      multi: true,
    },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: DATE_INPUT_FORMATE },
  ],
})
export class BirthDateComponent extends BaseComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @Input('min') minDate = null;
  @Input('max') maxDate = null;
  @Output() changeEvent = new EventEmitter<any>();

  onTouched: any = () => {};

  form: FormGroup = this.formBuilder.group({
    date: new FormControl(null, Validators.required),
  });

  constructor(private formBuilder: FormBuilder) {
    super();
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.destroy$.complete();
  }

  chosenYearHandler(normalizedYear: Moment) {
    this.form.get('date').setValue(moment())
    let ctrlValue = this.form.value['date'];
    ctrlValue.year(normalizedYear.year());
    this.form.get('date').setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    let ctrlValue = this.form.value['date'];
    ctrlValue.month(normalizedMonth.month());
    this.form.get('date').setValue(FunctionUtil.convertDateWithoutDays(new Date(ctrlValue)));
    datepicker.close();
  }

  registerOnChange(onChange: any): void {
    this.form.get('date').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(onChange);
  }

  writeValue(value: any) {
    if (value) this.form.get('date').setValue(value);
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  setDisabledState(disabled: boolean) {
    if (disabled) {
      this.form.get('date').disable();
    } else {
      this.form.get('date').enable();
    }
  }
}
